import React, { useState } from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import Container from "../components/Container";
 
 import { TiTick } from "react-icons/ti";
import { FaPlay } from "react-icons/fa";
 import about2 from "../images/about/qentrain-about.jpeg"
import about1 from "../images/cover5.jpg"
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
 
import loader from "../images/loader/loader1.jpg";
const About = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
  
    
    const showVideoModal = () => {
      setIsModalOpen(true);
    };
  
    
    const closeVideoModal = () => {
      setIsModalOpen(false);
    };
  

  return (
    <>
       <Meta 
        title="About Us"
        description="Learn more about The Best Sellers Shop, your go-to source for high-quality office furniture. We offer delivery, stock availability, quick ordering, and showroom visits." 
        keywords="office furniture, ergonomic chairs, desks, storage solutions"
      />
      <BreadCrumb title="About Us" />
<Container className="homer-wrapper-1">
  <div className="about-us-wrapper about-container-el-22">
    <div className="about-us-image">
      {/* Lazy load main dynamic image */}
      <LazyLoadImage
        alt='Qentrain Solutions'
        effect="blur"
        src={about1 || loader}
        placeholderSrc={loader}
        width="100%"
        height="100%"
        className="img-fluid mx-auto img-el"
      />

  
    </div>

    <div className="about-us-content">
    <div className="about-us-header">
        <span>Your Trusted Agri-Food Partner</span>
        <h2>Driving Excellence in Food Safety & Quality Across Africa</h2>
        <p>Qentrain Solutions Ltd is a leading technical consultancy firm specializing in ISO certification training, product development, and process optimization for agri-food enterprises. </p>
      </div>
      <div className="about-us-content-el">
        <div className="about-us-content-el-1">
          <div className="about-us-img-el">
                  <LazyLoadImage
                  alt='Qentrain Solutions'
                  
                  src={about2 || loader}
                  placeholderSrc={loader}
                  width="100%"
                  className="img-fluid mx-auto img-el"
                />
            <div className="play-button-wrapper-el">
              <div className="play-button-wrapper">
                <div className="circle-animation">
                  <div className="circle one"></div>
                  <div className="circle two"></div>
                </div>
                <span className="play-button">
                  <FaPlay className="play-icon"/>
                </span>
              </div>
            </div>
          </div>
       
          {isModalOpen && (
            <div className="video-modal-overlay" onClick={closeVideoModal}>
              <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
                <iframe
                  width="100%"
                  height="315"
                  src="https://www.youtube.com/embed/8DVKDseEF4M?si=EiKSh6YZHX0SDWga" 
                  title="Video Player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <button className="modal-close" onClick={closeVideoModal}>
                &times;
              </button>
            </div>
          )}
        </div>
        <div className="about-us-content-el-2">
          <p>With a team of seasoned experts, we empower businesses to achieve compliance, efficiency, and market competitiveness.</p>
          <p>"At Qentrain Solutions Ltd, we believe in practical, cost-effective solutions that drive business success."</p>
          <ul>
            <li>
              <TiTick className="tick-icon" /> Expert Consultation & Training
            </li>
            <li>
              <TiTick className="tick-icon" /> Practical Business Solutions
            </li>
            <li>
              <TiTick className="tick-icon" /> Sustainable Growth Strategies
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  
</Container>

    </>
  );
};

export default About;
